// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"9eca1a77","146":"7cab3959","190":"47007c3b"}[chunkId] + ".chunk.css";
};